





















































































































































































































































































import { mdiCheckCircleOutline } from '@mdi/js';
import { Component, Vue } from 'vue-property-decorator';
import { AuthModule } from '@/store/modules/auth';
import { NotificationModule } from '@/store/modules/notifications';
import { esiaUrlEdit } from '@/app.config';
import { isEmptyObject } from '@/utils/common';

@Component({
  data: () => ({
    mdiCheckCircleOutline,
    isEmptyObject,
  }),
})
export default class PersonProfileType extends Vue {
  readonly avatar = false;

  get isOrganization() {
    return AuthModule.isOrganization;
  }

  get user() {
    return AuthModule.user;
  }

  get identityDoc() {
    return this.user?.identityDoc || {};
  }

  get contactInfo() {
    return this.user?.contactInfo || {};
  }

  get fullName() {
    return `${this.user?.lastName} ${this.user?.firstName} ${this.user?.middleName ? this.user?.middleName : ''}`;
  }

  get gender() {
    return this.user?.gender === 'F' ? 'Женский' : 'Мужской';
  }

  get newNotificationCount() {
    return NotificationModule.newCount;
  }

  get getLetterByName() {
    return AuthModule.avatarLetter;
  }

  get esiaUrlEdit() {
    return esiaUrlEdit;
  }
  get isBusinessman() {
    return AuthModule.isBusinessman
  }
}
